import { validationIsEqual } from '../status';
import { validateAlphaNumericString } from '@om/validation';
import {
    AGENT_NAME_SET_VALUE,
    AGENT_CODE_SET_VALUE,
    setNameValid,
    setAgentCodeValid,
} from '../../../actions/personalAccident/agentModal';

let prevValidationAction = null;

export const agentModalFormValidation = (store, next, action) => {
    const validationAction = (() => {
        let error;

        const validateNameWithExtraSpaces = (value) => {
            const formattedValue = value.replace(/\s{2,}/g, ' ');

            let customError = validateAlphaNumericString(formattedValue, {
                min: 2,
                max: 48,
                subject: 'Name',
            });

            return customError;
        };

        switch (action.type) {
            case AGENT_NAME_SET_VALUE:
                error = validateNameWithExtraSpaces(action.value);
                return setNameValid(error);

            case AGENT_CODE_SET_VALUE:
                error = validateAlphaNumericString(action.value, {
                    subject: 'Agent Code',
                    min: 3,
                });
                return setAgentCodeValid(error);

            default:
                return null;
        }
    })();
    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
